interface Team {
  name: string;
  desc: string;
  descMore?: string | React.ReactNode;
}

const processMmgt: Team = {
  name: 'Prozess-Management',
  desc: 'Wir sind das Prozess-Management-Team und sind die ersten Ansprechpartner*innen, wenn es um das Thema Geschäftsprozessmanagement geht. Gemeinsam mit unseren Stakeholdern kümmern wir uns um die Aufnahme, Dokumentation, Analyse, Optimierung und Automatisierung der Prozesse innerhalb smavas.',
  descMore: (
    <>
      Unsere Vision ist es, unseren Kunden*innen durch die Abstimmung,
      Verbesserung und Automatisierung interner Prozesse die bestmöglichste
      Kundenreise von dem ersten Besuch auf unserer Website bis zum Abschluss
      eines Kredits bei einer unserer Partnerbanken zu bieten. Bei uns im
      Prozess-Management-Team wird Teamwork groß geschrieben - wir arbeiten viel
      und gern miteinander. Zudem unterstützen wir das cross-funktionale
      Arbeiten und den Austausch unter vielen verschiedenen Abteilungen und
      Teams, denn nur so können wir Prozesse vollumfänglich verstehen,
      optimieren und designen sowie Transparenz schaffen.
      <br />
      <br />
      Unsere Arbeitswerkzeuge sind neben Motivation und Spaß an der Arbeit die
      komplette BPM-Suite von Signavio sowie ein RPA-Tool und eine Workflow
      Engine.
    </>
  ),
};

const peopleTalent: Team = {
  name: 'People & Talent',
  desc: 'Wir sind das People & Talent Team! Unsere oberste Priorität ist die Ermöglichung eines professionellen Werdegangs für unsere Mitarbeiter*innen bei smava. Wir setzen dabei auf Best Practices und eine "can-do" Einstellung, um die besten Mitarbeiter*innen für unsere Teams zu gewinnen, zu fördern und zu entwickeln sowie zu halten. Angefangen bei umfangreichen Recruiting-Aktivitäten, über ein strukturiertes Onboarding bis hin zur Gestaltung von Karrierepfaden sind wir die erste Anlaufstelle. Und wir lieben es!',
  descMore:
    'Wir wollen das beste People & Talent Team in Deutschland werden, indem wir den Menschen, denen wir begegnen und mit denen wir zusammenarbeiten, die beste Kandidat*innen- und Mitarbeiter*innen-Erfahrung bieten, die sie je hatten. Wir arbeiten eng und proaktiv mit unseren internen Partnern*innen (wie Hiring Manager*innen und Führungskräften) und Mitarbeitern*innen aus allen vier Hauptbereichen zusammen: Zentrale Funktionen, Kundenberatung & Service, Marketing & Analytics sowie Engineering & Produkt. Wir schaffen eine offene Feedback-Umgebung, um stets die beste Lösung für unsere Mitarbeiter*innen zu finden. Dabei sind wir immer auf der Suche nach neuen Wegen, besseren Prozessen und State of the Art-Methoden im Hinblick auf den gesamten Kandidat*innen sowie Mitarbeiter*innen-Zyklus. Egal, ob Kandidat*in für einen Job, Praktikant*in oder Senior Manager*in - alle sollen bei uns die bestmögliche Erfahrung machen!',
};

const officeMmgt: Team = {
  name: 'Office & Facility Management',
  desc: 'Customers First! Als Service-Abteilung sehen wir es als unseren Standard an, unsere smavianer*innen jeden Tag glücklich zu machen. Focus on Impact! Unser Ansporn ist es, für unsere smavianer*innen eine bestmögliche Arbeitsumgebung zu schaffen und diese stetig weiterzuentwickeln, damit sich alle bestmöglich auf ihre Arbeit fokussieren können.',
};

const performanceMmgt: Team = {
  name: 'Performance Management',
  desc: 'Wir sind das Performance Management Team: Zahlenakrobat*innen und kreative Köpfe zugleich. Wir arbeiten eng mit der Analytics-Abteilung zusammen und unterstützen unsere Stakeholder (Sales und Customer Success) mit Zahlen, Fakten und Analysen. Neben Excel, Reports, KPIs und Analysen sind neben der Arbeit auch Stricken, Tretboot fahren und Witcher ganz groß im Rennen.',
  descMore:
    'Unsere Vision ist, die Produktivität im Vertrieb zu steigern. Dafür arbeiten wir cross-funktional an unterschiedlichen Projekten und bieten unseren Stakeholdern eine optimale Grundlage, um datengetriebene Entscheidungen zu treffen. Wir sind absolute Teamplayer! In unserer täglichen Arbeit stimmen wir uns mit unseren Stakeholdern ab und arbeiten dabei eng im Team zusammen. Wir holen uns Rat, unterstützen einander und feiern gemeinsam Erfolge.',
};

const qualityMmgt: Team = {
  name: 'Quality Management',
  desc: 'Wir sind das Qualitätsmanagement Team, kurz QM. QM optimiert gezielt Arbeitsabläufe, bestehende Produkte und Dienstleistungen. Dabei stellen wir sicher, dass wir sowohl intern, als auch extern einem höchstmöglichen Qualitätsanspruch gerecht werden.',
};

const presales: Team = {
  name: 'Pre-Sales',
  desc: 'Wir sind das Pre-Sales Team. Wir kümmern uns darum, unvollständige Kreditanfragen in direkter Zusammenarbeit mit unseren Kund*innen zu vervollständigen. Wir möchten alle Kund*innen durch beste und kompetente Beratung schnell und unkompliziert durch die Kreditanfrage führen.',
  descMore:
    'Ziel ist es, unsere Kundeberater*innen im Vertrieb durch unsere Vorarbeit zu unterstützen, indem wir viele Anfragen komplettieren und an sie weiterleiten. Unsere Werkzeuge sind ein CRM-Tool und das Headset. Wir arbeiten in einer flachen Hierarchie, in der alle voneinander lernen und die Arbeit Spaß macht. Durch regelmäßige Team-Meetings und Feedback bleiben wir up to date.',
};

const bankServices: Team = {
  name: 'Kreditprüfung & Sachbearbeitung',
  desc: '"Bank Services" ist ein Spezial-Team für die Sachbearbeitung und Prüfung von Kreditanträgen. Als Schnittstelle zwischen der Bank und den Kund*innen / Kreditberater*innen ist es unser Ziel, dass möglichst alle Kund*innen eine Auszahlung bei der Bank kommen.',
  descMore:
    'Dies erreichen wir bspw. durch frühzeitige und bessere Nachforderung sowie der Umleitung zu einer Alternativbank im Falle einer zu erwartenden Ablehnung.',
};

const customerSupport: Team = {
  name: 'Kundenservice',
  desc: 'Wir sind die erste Anlaufstelle für alle Fragen rund um smava. Wir kümmern uns darum, dass alle Kund*innen eine passende Antwort erhalten oder vermitteln sie an die entsprechenden Abteilungen. Kundenzufriedenheit und ein hohes Level an Service stehen bei uns an erster Stelle, denn zufriedene Kund*innen kommen gerne wieder. Unser Ziel ist es, den Service zu bieten, den sich unsere Kund*innen wünschen.',
  descMore:
    'Unsere Werkzeuge sind ein CRM-Tool und das Headset. Wir arbeiten in einer flachen Hierarchie, in der jeder vom anderen lernen kann und die Arbeit Spaß macht. Durch tägliche Team-Meetings und Feedbacks bleiben wir up to date. Unsere Schnittstellen zu allen anderen Bereichen, wie zum Beispiel Bank Service, Qualitätsmanagement und dem Vertrieb, machen uns zu einer wichtigen Anlaufstelle für unsere Kund*innen.',
};

const banking: Team = {
  name: 'Bank Kooperationen',
  desc: 'Nachdem smava 2012 die Banken mit an Bord geholt hat, wurde dieses Department zu einer der wichtigsten Säulen des Unternehmens: Hier werden mit viel Geschick und Passion die besten Konditionen für unsere Kund*innen ausgehandelt.',
};

const finance: Team = {
  name: 'Finance',
  desc: 'Der Fachbereich Finance ist ein wenig wie das Herz-Kreislaufsystem von smava. Alles, was hier tagtäglich passiert, läuft am Ende über unseren Tisch und wir schauen, dass der stetige Geldmittelfluss sichergestellt ist und alles korrekt erfasst wird. Dafür haben wir ein Team aus Spezialisten*innen, die das sehr schnell einschätzen und noch schneller in unseren Systemen erfassen.',
};

const legal: Team = {
  name: 'Legal, Risk & Compliance',
  desc: 'Wir sind das Legal, Risk & Compliance Team. Wir kümmern uns um alle rechtlichen und regulatorischen Themen. Wir unterstützen unsere smava Teams bei operativen und strategischen Entscheidungen, bei neuen Kooperationen sowie bei der Implementierung und Überwachung aller notwendigen Risiko- und Compliance-Strukturen.',
  descMore:
    'Wir statten unsere Teams mit allen notwendigen rechtlichen Informationen aus, um so die besten Entscheidungen für das Unternehmen treffen zu können. Wir unterstützen die Einführung neuer Produkte und vertreten und schützen smavas rechtliche Interessen. Wir folgen einem generalistischen Ansatz und arbeiten eng im Team sowie mit anderen Teams zusammen. Wir lieben es, uns mit komplexen Sachverhalten auseinander zu setzen und nach intelligenten Lösungen zu suchen.',
};

const strategy: Team = {
  name: 'Strategie',
  desc: 'Wir als "Strategy" Team wollen smavas Wachstum vorantreiben, indem wir strategische Projekte konzipieren und gemeinsam mit cross-funktionalen Teams bei smava implementieren. Da unsere Strategie auch für Investitionsgesellschaften maßgeblich ist, sind wir zudem in Investor Relations-Themen eingebunden. Indem wir stets als Pioniere agieren, treiben wir das Wachstum und die Profitabilität von smava voran. Für unsere Arbeit ist es essentiell, dass wir die interne sowie externe Umgebung ständig hinterfragen. Dabei stehen wir im engen Austausch mit dem C-Level. Für uns steht ein starkes Ownership, ständige Herausforderungen und Austausch mit allen relevanten Stakeholdern an erster Stelle und trägt maßgeblich zum Erfolg unserer Projekte bei.',
  descMore:
    'Für unsere Arbeit ist es essentiell, dass wir die interne sowie externe Umgebung ständig hinterfragen. Dabei stehen wir im engen Austausch mit dem C-Level. Für uns steht ein starkes Ownership, ständige Herausforderungen und Austausch mit allen relevanten Stakeholdern an erster Stelle und trägt maßgeblich zum Erfolg unserer Projekte bei.',
};

const analytics: Team = {
  name: 'Analytics',
  desc: 'Wir sind das Analytics-Team. Wir sind abteilungsübergreifend verantwortlich für alle Reports und Datenanalysen bei smava. Wir unterstützen smavas "Data Driven Culture" und die verschiedenen Teams in der Steuerung ihrer Aktivitäten. Unser Analytics Team ist in vier Unterabteilungen aufgeteilt: Marketing Analytics, Web Analytics, Sales Analytics sowie Business Analytics.',
  descMore:
    'Unser Tech Stack umfasst hauptsächlich Tableau, Postgres, BigQuery, Python, Google Analytics 360, Google Tag Manager & Segment. Wir arbeiten in enger Zusammenarbeit mit allen Abteilungen bei smava und haben dedizierte Analysten*innen für die meisten dieser Abteilungen. Unsere Analysten*innen genießen dabei viel Freiraum und Unabhängigkeit. Von Micro-Management sind wir kein Fan.',
};

const sales: Team = {
  name: 'Kundenberatung Vertrieb',
  desc: '„Wir machen Geld günstiger! Unser Ziel ist es, allen Kund*innen den günstigsten Kredit, den besten Service und die kompetenteste Kreditberatung überhaupt zu vermitteln. Bei uns geht es um die Lust an der Kommunikation und den gemeinsamen Weg mit unseren Kund*innen.“ Leistung, Ehrlichkeit und Humor werden bei uns großgeschrieben!“ (Tobias Wieschendahl, Senior VP Sales)',
  descMore: (
    <>
      Alles außer Kaltakquise: Über die unterschiedlichsten Kommunikationswege
      stellen unsere Kundenberater*innen Kontakt zu der zu uns strömenden
      (online) Kundschaft her. Alle unsere Berater*innen verfügen über einen
      eigenen Kundenstamm, somit haben unsere Kund*innen eine persönliche
      Ansprechperson, von der Anfrage bis zur Auszahlung. Die Beratung erfolgt
      per Telefon, E-Mail oder SMS. Täglicher Ansporn unseres Vertriebs-Teams:
      das Maximale aus einer Kreditanfrage herauszuholen und für unsere
      Kund*innen das beste Angebot zu erstellen. Für den reibungslosen Ablauf,
      auch während des Urlaubs oder der Krankheit unserer Kundenberater*innen,
      sorgt unser Vertretungs-Team. Unvollständige Kundendatensätze? Nicht bei
      smava! Für vollständige und qualitative Datensätze sorgen unsere
      Pre-Sales-Agents. Denn nur mit vollständigen Datensätzen können wir
      attraktive Angebote erstellen!
      <br />
      <br />
      <strong>Onboarding & Training:</strong> Neue Kolleg*innen erhalten eine
      fundierte Einführung in Fach-, Produkt- und Systemwissen sowie
      Kommunikations- und Vertriebsstrategien. Lerne von den Besten ihres Fachs!
      Weiterbildung wird bei smava großgeschrieben. Sei es durch
      praxisorientierte Präsenzschulungen oder E-Learning-Module.
      <br />
      <br />
      <strong> Karriereprogramm:</strong> Beruf kommt von Berufung und das
      bedeutet Aufstieg. Gemeinsam arbeiten wir mit dir an deiner Karriere und
      bieten dir Aufstiegschancen vom Professional, Senior-Kundenberater*in bis
      hin zum Teamleiter*in.
      <br />
      <br />
      <strong>Kultur:</strong> Gearbeitet wird in kleinen Teams von max. 10
      Personen. Gemeinsames Motivieren inklusive. Unsere Kundenberatung folgt
      dem Motto: Work hard, party hard. Im Vertrieb ist ständig was los, ob Beer
      Friday, Tombola, Casino-Besuch oder eine Reise. Erfolg wird gefeiert. Du
      bist richtig in smavas Vertriebs-Team, wenn du: kommunikationsstark bist,
      Lust am Umgang mit Kund*innen hast und die richtige Portion Humor und
      Ehrgeiz mitbringst.
      <br />
      <br />
      Ob Vertriebsprofi, Bank-Hintergrund oder Quereinsteiger*in mit
      Vertriebsriecher – mit dem Willen zum Erfolg, Disziplin und der richtigen
      Einstellung kannst du bei uns durchstarten!
    </>
  ),
};

const marketing: Team = {
  name: 'Marketing',
  desc: 'Wir sind das Marketing-Team! Wir sorgen dafür, dass so viele Kunden*innen wie möglich den Weg zu smava finden und dass unsere Marke mehr und mehr bekannt wird. Dazu nutzen wir alle erdenklichen Marketing-Kanäle sowie Performance- und Brand-Marketing-Kampagnen. Unser Ziel? Datengetriebenes und innovatives Marketing. Neben etablierten Marketing-Kanälen wie TV und Radio, finden wir auch auf neuen Medien wie Display und Social Media den besten und effizientesten Ansatz und erhöhen gleichzeitig unsere Markenbekanntheit.',
  descMore:
    'Wir verfolgen einen starken Performance-Ansatz in Kombination mit Brand-Maßnahmen. Aus diesem Grund besteht unsere Marketing-Abteilung aus insgesamt neun Teams. Dies erlaubt uns, jeden Marketing-Kanal mit maximalem Know-How zu steuern und die besten Ergebnisse zu erzielen. Da wir einen data-driven-Marketing-Ansatz verfolgen, arbeiten wir eng mit dem Analytics-Team zusammen. Darüber hinaus gibt es zahlreiche Projekte, bei denen wir zusammen mit Abteilungen wie Legal oder dem Engineering- und Produkt-Team arbeiten. Wir haben viele erfahrene Kollegen*innen in unseren Marketing-Teams, von denen vor allem unerfahrene Talente lernen und selbst Karriere machen können.',
};

const produkt: Team = {
  name: 'Produkt',
  desc: 'Im Produkt designen wir Lösungen und Features der Zukunft und implementieren diese durch flexible Grundsätze. Mobilität steht bei smava an erster Stelle. Unsere Kundschaft steht immer im Fokus von dem, was wir alle machen (User-zentriertes Design). Willst du an einer self-service Applikation mit höchster Qualität arbeiten? Unser Ziel ist es, allen unseren Kund*innen den für sie perfekten Kredit zu bieten und das schnell, unkompliziert und nachhaltig. Was definiert die perfekte Kreditplattform der Zukunft? Dies sind die zentralen Fragestellungen, die durch unsere Product Owner*innen und Designer*innen adressiert werden!',
  descMore:
    'Die Schlüssel-Features unserer Arbeit sind ein zugängliches Design für alle Endgeräte, voll-digital ohne Media Gaps und flexible Kollaborationen in cross-funktionalen Teams. Wir verfolgen einen datengetriebenen Kurs, um den Markt und das Kundenverhalten zu verstehen und vorherzusagen, indem komplexe Datenanalysen und Machine Learning Algorithmen benutzt werden.',
};

const engineering: Team = {
  name: 'Engineering',
  desc: 'Alle, die für smava arbeiten, besitzen umfassende Erfahrung, sind Expert*innen auf ihrem Arbeitsgebiet und wissen genau, was getan werden muss. Wir sind Software Engineers, nicht einfach Entwickler*innen. Wir arbeiten cross-funktional und coden auf eine Art und Weise, dass unsere Codes Einfluss auf die User haben, von der UI bis hin zur Datenbank. Wir überwachen diese Auswirkungen unseres Codings durch User Research, fullstack Analysen, End-to-End-Tests und eine ganzheitliche Herangehensweise, die den gelieferten Mehrwert aufzeigen.',
  descMore: (
    <>
      Du wirst hier auf hochprofessionelle Software Engineers von der
      Backend-Seite (z. B. Java Spring, Go, PostgreSQL, Microservices Docker,
      AWS) und Frontend-Seite (z. B. React, Redux, Webpack, etc.) treffen. Das
      Ganze wird durch das Software Quality Assurance Team komplettiert, das für
      die Qualität der Codes verantwortlich ist (manuelles und automatisiertes
      Testen, Selenium WebDriver/Grid & Jenkins).
      <br />
      <br />
      Unterdessen stellen unsere Systemadmins sicher, dass unsere
      Mitarbeiter*innen zuverlässige, moderne Systeme für ihre Arbeit besitzen
      (Windows and Linux Server, OpenVPN, IPSec VPN, SSL-VPN, Wi-Fi, VLAN, LAN,
      VMWare ESX).
      <br />
      <br />
      Darüber hinaus arbeitet unser Data Engineering Team an event-bus
      architecture und Data Lake (AWS, Kafka).
      <br />
      <br />
      Wir arbeiten ununterbrochen daran, unsere Kreditlösungen zu verbessern.
      Der Fokus liegt hierbei darauf, unsere Kreditvergleichsplattform immer
      weiterzuentwickeln und auf ein neues Level zu pushen. Unsere
      Projektmanager*innen implementieren neue Features und verbessern bereits
      existierende Komponenten.
      <br />
      <br />
      <strong>Architectural autonomy.</strong> Bei smava steuern
      cross-funktionale Teams das Grundgerüst ihrer Software-Komponente. Sie
      präsentieren ihren Kolleg*innen neue Ideen, kollaborieren in
      domänenübergreifenden Projekten und besitzen die technische Roadmap
      unserer Komponenten. Sie beeinflussen technische Änderungen durch
      Architecture Review Boards, technische Deep Dives und Demonstrationen von
      Prototypen.
      <br />
      <br />
      <strong>Publishing und Monitoring.</strong> Wir haben den
      “Veröffentlichungs-Button” direkt am Schreibtisch. Bei smava glauben wir
      an die Philosophie: You build it, you run it. Das bedeutet, dass Software
      Engineers nicht nur das Gebaute besitzen und den Zyklus ihrer Komponenten
      veröffentlichen, sondern auch Production Support bieten und die Stabilität
      für die End-User sicherstellen. Wir geben unseren Entwicklern*innen Tools
      und Prozesse, die uns die Auswirkungen unserer Codes auf die Produktion
      für die User sehen lassen.
      <br />
      <br />
      <strong>Wissensweitergabe.</strong> Wir glauben an Kollaboration. Ob es
      nun Hackathons, Product/Feature-Demos, Guilds, Task Forces, Pair
      Programming sind: Such dir was aus! Viele cross-funktionale Teams, die ihr
      Wissen teilen und weitergeben, was sie wiederum selbst von anderen Teams
      oder einem/r Entwickler*in erwerben konnten, zeigen so, wie wichtig das
      auch für den Erfolg jedes einzelnen Engineers ist.
      <br />
      <br />
      <strong>Flache Hierarchien.</strong> Unser Senior Management ist darauf
      bedacht, regelmäßig mit ihren Teammitgliedern zu sprechen und ihre Teams
      initiativ in die wechselnden Strukturen und Prozesse einer Abteilung zu
      involvieren. Wir definieren und überprüfen regelmäßig unser Grundgerüst,
      on-call, Entwicklungsprozesse sowie Teamstrukturen.
    </>
  ),
};

export const teamsList: Team[] = [
  engineering,
  produkt,
  marketing,
  sales,
  analytics,
  strategy,
  legal,
  finance,
  banking,
  customerSupport,
  bankServices,
  presales,
  qualityMmgt,
  performanceMmgt,
  processMmgt,
  officeMmgt,
  peopleTalent,
];
